import LockSearch from './LockSearch';

export default LockSearch;
